export default {
  methods: {
    toString(value) {
      if (!value) return "";

      return value.toString();
    }
  }
}
